const events = [
  {
    event: "Green Thumb Farming Workshop",
    desc: "Learn sustainable farming techniques and eco-friendly practices for a greener future.",
    image:
      "https://images.unsplash.com/photo-1487357298028-b07e960d15a9?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    event: "Organic Harvest Festival",
    desc: "Join us to celebrate organic farming with fresh produce, music, and educational activities.",
    image:
      "https://images.unsplash.com/photo-1515150144380-bca9f1650ed9?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    event: "Medicinal Herbs Discovery Tour",
    desc: "Explore the world of medicinal herbs and their healing properties in this informative tour.",
    image: "https://images.unsplash.com/photo-1678483874079-4b72669a8f2f?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    event: "Urban Gardening Bootcamp",
    desc: "Get hands-on experience and expert tips for successful urban gardening in small spaces.",
    image: "https://plus.unsplash.com/premium_photo-1664200630491-5f0bda86db50?q=80&w=1742&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
];

export default events;
